import { useNavigate } from "react-router-dom";
import session from "../../utils/session";
import Logout from "../../api/logout";
import local from "../../utils/local";

// 관리화면 네비게이션 메뉴 
const MngrNavi = ({
    pgmId
}) => {
    const navigate = useNavigate();

    return (
        <nav
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 20px',
                borderBottom: '1px solid #eee',
                maxWidth : '1600px',
                margin : '20px auto',
            }}
        >
            {/* 왼쪽: 로고 */}
            <div
                className="flex items-center cursor-pointer"
                onClick={() => navigate('/')}
            >
                <div className="flex h-[34px] w-[34px] items-center justify-center rounded-lg bg-gradient-to-r from-theme-1 to-theme-2 transition-transform ease-in-out">
                    <div className="relative h-[16px] w-[16px] -rotate-45 [&_div]:bg-white">
                        <div className="absolute inset-y-0 left-0 my-auto h-[75%] w-[21%] rounded-full opacity-50"></div>
                        <div className="absolute inset-0 m-auto h-[120%] w-[21%] rounded-full"></div>
                        <div className="absolute inset-y-0 right-0 my-auto h-[75%] w-[21%] rounded-full opacity-50"></div>
                    </div>
                </div>
            </div>

            {/* 가운데: 메뉴 */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '20px',
                    flexGrow: 1,
                }}
            >
                <span onClick={() => navigate('/ntfctMng')} className={pgmId === 'NtfctMng' ? 'act' : ''} style={{ cursor: 'pointer' }}>
                    알림관리
                </span>
                <span onClick={() => navigate('/docMng')} className={pgmId === 'DocMng' ? 'act' : ''} style={{ cursor: 'pointer' }}>
                    문서관리
                </span>
            </div>

            {/* 오른쪽: 사용자 정보 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', height: '32px' }}>
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <span style={{ textDecoration: 'underline' }}>
                        {`${local.SESSION_USER_NAME} 님`}
                    </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Logout />
                </div>
            </div>
        </nav>
    );
};

export default MngrNavi;
